import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Home,
    meta: {
      requireAuth: false,
      icon: 'tachometer-alt',
    }
  },
  {
    path: '/event-view/:id?',
    name: 'Ausfahrten',

    meta: {
      requireAuth: true,
      icon: 'skiing',
      group: 'Veranstalltungen'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "app-participants" */ '../views/Events.vue'),
    children: [
      {
        path: 'participants',
        component: () => import(/* webpackChunkName: "app-participants" */ '../components/participants/Participant.vue'),
        name: 'participantlist'
      },
      {
        path: '',
        component: () => import(/* webpackChunkName: "app-participants" */ '../components/participants/Participant.vue'),
      },
      {
        // UserPosts will be rendered inside User's <router-view>
        // when /user/:id/posts is matched
        path: 'event', component: () => import(/* webpackChunkName: "app-participants" */ '../components/events/Event.vue'),
        name: 'eventconfig'
      },
      {
        // UserPosts will be rendered inside User's <router-view>
        // when /user/:id/posts is matched
        path: 'room-assignment', component: () => import(/* webpackChunkName: "app-participants" */ '../components/rooms/RoomAssignment.vue'),
        name: 'roomconfig',
      }, {
        path: 'course-assignment', component: () => import(/* webpackChunkName: "app-participants" */ '../components/courses/Courses.vue'),
        name: 'courseconfig'
      }, {
        path: 'billing', component: () => import(/* webpackChunkName: "app-participants" */ '../components/events/EventBilling.vue'),
        name: 'eventbilling'
      }
    ]
  },
  {
    path: '/instructor-statistik',
    name: 'Instructor Statistik',
    component: () => import('../views/InstructorStatistics.vue'),
    meta: {
      requireAuth: true,
      icon: 'chart-bar',
      group: 'Veranstalltungen'
    }
  },
  {
    path: '/members',
    name: 'Mitgliederanpassung',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "app-members" */ '../views/Members.vue'),
    meta: {
      requireAuth: true,
      requireRoles: [
        'Admin'
      ],
      icon: 'users-cog',
      group: 'Mitglieder'
    }
  },
  {
    path: '/members/annual-billing',
    name: 'Jaehrliche Mitgliederabrechnung',
    component: () => import(/* webpackChunkName: "app-members" */ '../views/AnnualBilling.vue'),
    meta: {
      requireAuth: true,
      requireRoles: [
        'Admin'
      ],
      icon: 'calculator',
      group: 'Mitglieder'
    }
  },
  {
    path: '/memberlist',
    name: 'Mitgliederliste',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "app-members" */ '../views/Memberslist.vue'),
    meta: {
      requireAuth: true,
      requireRoles: [
        'Vorstand', 'Admin', 'Users'
      ],
      icon: 'users-cog',
      group: 'Mitglieder'
    }
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
